module.exports = __webpack_public_path__ + "static/img/tutoriales sin texto utopie-8.ffedef01.jpg";